export const uploadHoofdstuk = {
  state: {
    byId: {},
    hoofdstukToIds: {},
    allIds: [],
  },
  reducers: {
    // {
    //   uploadPageId: int,
    // }
    removeUploadHoofdstukElement: function(state, payload){
      let newById = {};
      let newHoofdstukToIds = {};
      Object.keys(state.hoofdstukToIds).forEach(key => {
        let tmpObj = {};
        Object.keys(state.hoofdstukToIds[key]).forEach(tmp => {
          if(state.hoofdstukToIds[key][tmp] !== payload.uploadPageId){
            tmpObj[tmp] = state.hoofdstukToIds[key][tmp]
          }
        })
        newHoofdstukToIds[key] = tmpObj;
      });

      Object.keys(state.byId).filter(key => {
        return key !== payload.uploadPageId
      }).forEach(data => {
        newById[data] = state.byId[data];
      });

      // return state;
      let newState = Object.assign({}, state, {
        byId: newById,
        hoofdstukToIds: newHoofdstukToIds,
      });
      return newState;
    },

    // Expected payload:
    // {
    //   id: int,
    //   uploadPageId: int,
    //   questionId: int,
    //   alternativeName: int,
    //   showIndex: int,
    //   merge: int,
    //   order: int,
    // }
    addUploadHoofdstukElement: function(state, payload){
      let newById = state.byId;
      let obj = {};
      obj[payload.id] = {
        id: payload.id,
        uploadPageId: payload.uploadPageId,
        questionId: payload.questionId,
        alternativeName: payload.alternativeName,
        showIndex: payload.showIndex,
        merge: payload.merge
      };

      newById = Object.assign({}, newById, obj);
      let newHoofdstukToIds = state.hoofdstukToIds;
      let objToAdd = {};
      objToAdd[payload.order] = payload.id;
      if(Object.keys(newHoofdstukToIds).includes(payload.uploadPageId)){
        newHoofdstukToIds[payload.uploadPageId] = Object.assign({},
          newHoofdstukToIds[payload.uploadPageId], objToAdd);
      } else {
        newHoofdstukToIds[payload.uploadPageId] = objToAdd;
      }
      return {
        byId: newById,
        hoofdstukToIds: newHoofdstukToIds,
        allIds: [...state.allIds, payload.id]
      };
    },

    // Expected payload:
    // {
    //   id: hoofdstukId,
    //   order: obj
    // }
    fixOrder: function(state, payload){
      let object = {};
      object[payload.id] = {};
      if(payload.order.length > 0){
        payload.order.forEach(obj => {
          object[payload.id][obj.order] = obj.id;
        });
      }
      let res =  Object.assign({}, state, {
        hoofdstukToIds: Object.assign({}, state.hoofdstukToId, object)
      });
      return res;
    },

    // {
    //   id: int
    //   key: val,
    // }
    changeUploadElement(state, payload){
      let obj = {};
      obj[payload.id] = Object.assign({}, state.byId[payload.id], payload);
      let newById = Object.assign({}, state.byId, obj);
      return Object.assign({}, state, {
        byId: newById,
      });
    },
  }
}
